import Vue from 'vue';
import Component from 'vue-class-component';

import eventBus from 'common/plugins/eventBus';

import WhiteMarker from 'common/assets/images/Marker.png';
import RedMarker from 'common/assets/images/MarkerSelected.png';
import WhiteDefaultMarker from 'common/assets/images/MarkerDefault.png';
import RedDefaultMarker from 'common/assets/images/MarkerDefaultSelected.png';

@Component({
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
      description: 'Map instance from google maps',
    },
    infoWindow: {
      type: Object,
      required: true,
    },
    markers: {
      type: Array,
      required: false,
    },
    showInfoBegining: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    BbGoogleMapCustomInfoWindow: () =>
      import(
        /* webpackChunkName: "BbGoogleMapCustomInfoWindow" */ 'common/components/Map/BbGoogleMapCustomInfoWindow'
      ),
    BbGoogleMapDefaultInfoWindow: () =>
      import(
        /* webpackChunkName: "BbGoogleMapDefaultInfoWindow" */ 'common/components/Map/BbGoogleMapDefaultInfoWindow'
      ),
    BbGoogleMapSellingSpotInfoWindow: () =>
      import(
        /* webpackChunkName: "BbGoogleMapSellingSpotInfoWindow" */ 'common/components/Map/BbGoogleMapSellingSpotInfoWindow'
      ),
  },
})
export default class BbGoogleMapInfoWindowComponent extends Vue {
  selectedMarker = null;
  flag = true;
  loadingInfoWindow = false;
  context = null;

  created() {
    this.gmapsInfoWindow = new this.google.maps.InfoWindow({
      ...this.infoWindow.settings,
    });
    this.addMarkerClickListener();
  }

  mounted() {
    /**
     * if we need to show the information of a marker in the first render,
     * only the first marker will be shown
     */
    if (this.showInfoBegining && this.markers.length) {
      this.clickMarkerBehavior(this.markers[0]);
    }
  }

  beforeDestroy() {
    eventBus.$off('markerClicked', this.clickMarkerBehavior);
  }

  /**
   * listeing 'markerClicked' emited by 'BbGoogleMapLoader' component.
   */
  addMarkerClickListener() {
    eventBus.$on('markerClicked', this.clickMarkerBehavior);
  }

  clickMarkerBehavior(marker) {
    this.gmapsInfoWindow.open(this.google.maps, marker);
    this.switchMarker(marker, marker.icon.scaledSize);
    this.gmapsInfoWindow.setContent(this.$refs.infoWindowContent);
    this.setContext();
  }

  /**
   * Load the infoWindow context, if is a function, it will be a promise/query to resolve
   * in the other hand, it will be just an object.
   */
  async setContext() {
    this.loadingInfoWindow = true;
    const { infoWindowContext } = this.selectedMarker.marker;
    if (typeof infoWindowContext === 'function') {
      const response = await infoWindowContext();
      this.context = response.data.infoWindowContext;
    } else {
      this.context = infoWindowContext;
    }
    this.loadingInfoWindow = false;
  }

  switchMarker(marker, size) {
    const labelMarker = marker.getLabel();
    const lightYellow = '#FDC701';
    let whiteMarker = WhiteMarker;
    let redMarker = RedMarker;

    /**
     * In case you have to show the default markers.
     */
    if (!marker.customMarker) {
      whiteMarker = WhiteDefaultMarker;
      redMarker = RedDefaultMarker;
    }

    /**
     * When selecting a marker, check if there is no other one selected
     * using the variable 'selectedMarker'. If there is enter the first 'if'
     */
    if (this.selectedMarker !== null) {
      const labelselectedMarker = this.selectedMarker.getLabel();
      /**
       * If there is a selected marker and we click on another, change
       * the properties of the first one to leave it by default while
       * the second one selects it.
       */
      if (this.selectedMarker !== marker) {
        this.changeMarkerProperties(
          this.selectedMarker,
          labelselectedMarker,
          whiteMarker,
          size,
          lightYellow,
        );
        this.changeMarkerProperties(
          marker,
          labelMarker,
          redMarker,
          size,
          'white',
        );
      } else {
        /**
         * if we click on the same marker previously selected, 'this.flag'
         * will go to 'true' and the tooltip will be hidden and the properties
         * of the marker will be changed so that it is deselected.
         */
        if (this.flag) {
          this.changeMarkerProperties(
            this.selectedMarker,
            labelselectedMarker,
            whiteMarker,
            size,
            lightYellow,
          );
          this.gmapsInfoWindow.close();
        } else {
          this.changeMarkerProperties(
            this.selectedMarker,
            labelselectedMarker,
            redMarker,
            size,
            'white',
          );
        }
        this.flag = !this.flag;
      }
    } else {
      /**
       * If no other bookmark is selected, change the properties of the current one.
       */
      this.changeMarkerProperties(
        marker,
        labelMarker,
        redMarker,
        size,
        'white',
      );
    }

    /**
     * Saves the data of the selected marker as within the variable 'selectedMarker'.
     * 'this.map.panTo' allows me to center the map depending on the selected marker.
     */
    this.selectedMarker = marker;
    this.map.panTo(marker.getPosition());
  }

  changeMarkerProperties(marker, label, icon, size, color) {
    marker.setIcon({ url: icon, scaledSize: size });
    if (marker.customMarker) {
      label.color = color;
    }
  }
}
